import { apiClient } from "../../api/services/api.service";

export const fetchUsers = async (params?: any) =>
    await apiClient.get('/users/', { params });

export const createUser = async (payload: any) =>
    await apiClient.post('/users/', payload);

export const getUser = async (id: string) =>
    await apiClient.get(`/users/${id}/`);

export const updateUser = async (id: string, payload: any) =>
    await apiClient.patch(`/users/${id}/`, payload);

export const deleteUser = async (id: string) =>
    await apiClient.delete(`/users/${id}/`);

export const fetchRoles = async () =>
    await apiClient.get('/roles/');

// Admin: Create role
export const createRole = async (payload: { name: string; permissions: string[] }) =>
    await apiClient.post('/roles/', payload);

// Admin: Update role permissions
export const updateRole = async (id: number, payload: { permissions: string[] }) =>
    await apiClient.patch(`/roles/${id}/`, payload);

// Admin: Delete role
export const deleteRole = async (id: number) =>
    await apiClient.delete(`/roles/${id}/`);

// Admin: Suspend user
export const suspendUser = async (id: string) =>
    await apiClient.post(`/users/${id}/suspendre/`);

// Admin: Activate user
export const activateUser = async (id: string) =>
    await apiClient.post(`/users/${id}/activer/`);

// Admin: User stats
export const fetchUserStats = async (id: string) =>
    await apiClient.get(`/users/${id}/stats/`);

// Admin: User activity (30 days)
export const fetchUserActivite = async (id: string) =>
    await apiClient.get(`/users/${id}/activite/`);

// Admin: User's decisions
export const fetchUserDecisions = async (id: string) =>
    await apiClient.get(`/users/${id}/decisions/`);
